import Lenis from 'lenis';

let lenis = null;

export function initSmoothScroll() {
  if (typeof window === 'undefined') return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (lenis) return;
  lenis = new Lenis({ duration: 1.15, smoothWheel: true });
  const raf = (time) => {
    lenis.raf(time);
    requestAnimationFrame(raf);
  };
  requestAnimationFrame(raf);
}

export function scrollToId(selector) {
  const el = document.querySelector(selector);
  if (!el) return;
  if (lenis) lenis.scrollTo(el, { offset: -88 });
  else el.scrollIntoView({ block: 'start' });
}

export function scrollToTop() {
  if (lenis) lenis.scrollTo(0, { immediate: true });
  else window.scrollTo(0, 0);
}

export function stopScroll() {
  if (lenis) lenis.stop();
  document.body.style.overflow = 'hidden';
}

export function startScroll() {
  if (lenis) lenis.start();
  document.body.style.overflow = '';
}
